import { Component, Input, OnInit } from '@angular/core';
import { LdsUserService } from '../../services/lds-user.service';
import { WsPacketService } from '../../lds-websocket-module/ws-packet/ws-packet.service';
import { WsChatService } from '../../lds-websocket-module/ws-chat/ws-chat.service';

@Component({
    selector: 'ds-battery-list',
    templateUrl: './battery-list.component.html',
    styleUrls: ['./battery-list.component.scss'],
    standalone: false
})
export class BatteryListComponent implements OnInit {

  featureSets: any;


  constructor(public user: LdsUserService, private wsPacket: WsPacketService, private wsChat: WsChatService) {
  }

  async ngOnInit() {
    this.featureSets = [];

    this.user.currentModule = "Battery Devices";

    for (let i in this.user.batteryFeatureSets) {
      this.loadValue(this.user.batteryFeatureSets[i]);
    }

  }



  async loadValue(featureSet) {

    let packet = this.wsPacket.getPacket('feature', 'read', {
      featureId: featureSet.batteryFeature
    })

    let res = await this.wsChat._sendMsg(packet);
    if (res.items[0].success) {
      this.user.features[featureSet.batteryFeature].attributes.value = res.items[0].payload.value;
      this.featureSets.push(featureSet);
    }

    if(this.featureSets.length > 1){
    this.featureSets.sort((f1, f2) => {
      const value1 = this.user.features[f1.batteryFeature].attributes.value;
      const value2 = this.user.features[f2.batteryFeature].attributes.value;
      if(value1 > value2){
        return 1;
      }


      if(value1 < value2){
        return -1;
      }

      return 0;
    });
  }
  }
}
